export function safePortalLink(value) {
  if (typeof value !== 'string' || /[\s\u0000-\u001f\\]/.test(value)) return '';
  if (!value || value.startsWith('#') || (value.startsWith('/') && !value.startsWith('//'))) return value;
  try { const u = new URL(value); return ['http:', 'https:', 'mailto:', 'tel:'].includes(u.protocol) && !u.username && !u.password ? value : ''; }
  catch (_) { return ''; }
}

export function preparePortalValue(value, imageResolver) {
  if (typeof value === 'string') return /^(asset|media):/.test(value) ? imageResolver(value) : value;
  if (Array.isArray(value)) return value.filter(item => !item || typeof item !== 'object' || item.visible !== false).map(item => preparePortalValue(item, imageResolver));
  if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).filter(([key]) => !['__proto__', 'constructor', 'prototype'].includes(key)).map(([key, item]) => [key, preparePortalValue(item, imageResolver)]));
  return value;
}
